import { Navigate, Outlet } from "react-router"
import useAuthContext from "@/contexts/auth/use-context"

export const ProtectedRoute = () => {
  const { isLoggedIn } = useAuthContext();

  if (!isLoggedIn) {
    return <Navigate to="/auth-login" replace />;
  }

  return <Outlet />;
};